import { IMAGE_PATH } from '../assets/pronto.js';

var brand = {
  luminate: {
    name: 'Walmart Luminate',
    logo: IMAGE_PATH === null || IMAGE_PATH === void 0 ? void 0 : IMAGE_PATH['walmart-luminate-purple-logo'],
    altText: 'WalmartLuminate'
  },
  scintilla: {
    name: 'Scintilla',
    logo: IMAGE_PATH === null || IMAGE_PATH === void 0 ? void 0 : IMAGE_PATH['scintilla-purple-logo'],
    altText: 'Scintilla'
  }
};
var REBRANDED_NAME = 'Scintilla';
var constants = {
  brand: brand,
  REBRANDED_NAME: REBRANDED_NAME
};

export { constants as default };
